import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem,
} from './ui/dropdown-menu';

const LanguageSwitcher = ({ compact = false, className = '' }) => {
  const { i18n, t } = useTranslation();
  const current = i18n.language === 'ar' ? 'ar' : 'fr';

  const change = (lng) => {
    if (lng !== current) i18n.changeLanguage(lng);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="lang-switcher"
        className={`inline-flex items-center gap-1 px-2 py-1 rounded hover:bg-white/10 text-inherit focus:outline-none ${className}`}
        aria-label={t('lang.switch')}
      >
        <Globe className="w-3.5 h-3.5" />
        {!compact && <span className="font-medium uppercase">{current}</span>}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[140px]">
        <DropdownMenuItem onClick={() => change('fr')} data-testid="lang-fr" className={current === 'fr' ? 'font-semibold text-[#1F4D3F]' : ''}>
          🇫🇷 {t('lang.fr')}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => change('ar')} data-testid="lang-ar" className={current === 'ar' ? 'font-semibold text-[#1F4D3F]' : ''}>
          🇩🇿 {t('lang.ar')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
